import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';
import axios from 'axios';
import logo from '../images/logo.png';
import { apiUrl } from './config';

const ResetPassword = () => {
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    // Il link vale una volta sola: al secondo invio il server risponde che e'
    // gia' stato usato. Chi non vedeva succedere niente premeva di nuovo e si
    // trovava davanti un errore, convinto che la password non fosse cambiata.
    const [inCorso, setInCorso] = useState(false);
    const [fatto, setFatto] = useState(false);

    const handleSubmit = async () => {
        if (inCorso || fatto) return;

        const passwordPattern = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
        
        if (!passwordPattern.test(newPassword)) {
            message.error('La password deve contenere almeno 8 caratteri e includere almeno un numero.');
            return;
        }

        if (newPassword !== confirmPassword) {
            message.error('Le password non corrispondono.');
            return;
        }

        setInCorso(true);

        try {
            await axios.post(`${apiUrl}/api/auth/reset-password/${token}`, {
                newPassword,
            });

            setFatto(true);
        } catch (error) {
            console.error('Errore durante il reset della password:', error);

            // Il messaggio del server distingue il link gia' usato da tutto il
            // resto: ripeterlo evita di far ricominciare chi ha gia' finito.
            const detto = error.response?.data?.message;
            message.error(detto || 'Errore durante il reset della password. Riprova tra poco.');
        } finally {
            setInCorso(false);
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);
        
        const passwordPattern = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
        if (!passwordPattern.test(value)) {
            setPasswordError('La password deve contenere almeno 8 caratteri e includere almeno un numero.');
        } else {
            setPasswordError(''); // Rimuove l'errore quando la password rispetta i requisiti
        }
    };

    return (
        <div style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            backgroundColor: 'var(--sfondo)',
        }}>
            <div style={{ 
                width: '100%', 
                maxWidth: '400px', 
                padding: '20px', 
                backgroundColor: '#ffffff', 
                textAlign: 'center',
            }}>
                <img 
                    src={logo} 
                    alt="FitLab Logo" 
                    style={{ 
                        width: '100%', 
                        maxWidth: '200px', 
                        margin: '0 auto 10px' 
                    }} 
                />
                <div className="change-title">
                    RESETTA LA TUA PASSWORD
                </div>

                {fatto ? (
                    <div style={{ padding: '10px 0 20px' }}>
                        <p style={{ fontSize: '17px', color: 'var(--inchiostro)', margin: '0 0 10px' }}>
                            Password aggiornata.
                        </p>
                        <p style={{ fontSize: '15px', color: 'var(--testo)', margin: 0, lineHeight: 1.6 }}>
                            Torna nell'app FitLab e accedi con la password che hai appena scelto.
                            Questa pagina puoi chiuderla.
                        </p>
                    </div>
                ) : (
                <Form layout="vertical" onFinish={handleSubmit}>
                    <Form.Item 
                        label="Nuova Password" 
                        required
                        validateStatus={passwordError ? 'error' : ''}
                        help={passwordError} // Mostra il messaggio di errore
                    >
                        <Input.Password 
                            value={newPassword} 
                            onChange={handlePasswordChange} 
                        />
                    </Form.Item>
                    <Form.Item 
                        label="Conferma Password" 
                        required
                        validateStatus={confirmPassword && newPassword !== confirmPassword ? 'error' : ''}
                        help={confirmPassword && newPassword !== confirmPassword ? 'Le password non corrispondono' : ''}
                    >
                        <Input.Password 
                            value={confirmPassword} 
                            onChange={(e) => setConfirmPassword(e.target.value)} 
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button 
                            type="primary" 
                            htmlType="submit" 
                            block 
                            loading={inCorso}
                            disabled={inCorso}
                            
                            style={{ 
                                backgroundColor: 'var(--primario)', 
                                borderColor: 'var(--primario)', 
                                fontSize: '16px', 
                                padding: '10px', 
                                borderRadius: '6px' 
                            }}
                        >
                            Resetta Password
                        </Button>
                    </Form.Item>
                </Form>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
